module.exports = __webpack_public_path__ + "img/ctrl-cross-resonance-stub-down-0.a3518970.svg";